/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { ERC165Feature, ERC165FeatureInterface } from "../ERC165Feature";

const _abi = [
  {
    inputs: [],
    name: "FEATURE_NAME",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "FEATURE_VERSION",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportInterface",
    outputs: [
      {
        internalType: "bool",
        name: "isSupported",
        type: "bool",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
];

const _bytecode =
  "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";

export class ERC165Feature__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ERC165Feature> {
    return super.deploy(overrides || {}) as Promise<ERC165Feature>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): ERC165Feature {
    return super.attach(address) as ERC165Feature;
  }
  connect(signer: Signer): ERC165Feature__factory {
    return super.connect(signer) as ERC165Feature__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ERC165FeatureInterface {
    return new utils.Interface(_abi) as ERC165FeatureInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ERC165Feature {
    return new Contract(address, _abi, signerOrProvider) as ERC165Feature;
  }
}
